export const encodeURL = (string: string) => encodeURIComponent(string)
export const decodeURL = (string: string) => decodeURIComponent(string)
